import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { customEndpointFunctions } from "./customEndpointFunctions";
import { endpointFunctions } from "./endpointFunctions";
import { evaluateExpression } from "./evaluateExpression";
export var callFunction = function callFunction(_ref, options) {
  var fn = _ref.fn,
    argv = _ref.argv;
  var evaluatedArgs = argv.map(function (arg) {
    return ["boolean", "number"].includes(typeof arg) ? arg : evaluateExpression(arg, "arg", options);
  });
  var fnSegments = fn.split(".");
  if (fnSegments[0] in customEndpointFunctions && fnSegments[1] != null) {
    var _customEndpointFuncti;
    return (_customEndpointFuncti = customEndpointFunctions[fnSegments[0]])[fnSegments[1]].apply(_customEndpointFuncti, _toConsumableArray(evaluatedArgs));
  }
  return endpointFunctions[fn].apply(endpointFunctions, _toConsumableArray(evaluatedArgs));
};